<div class="relative flex flex-wrap items-center gap-4">
  <!-- <img
    loading="lazy"
    src="assets/icons/Search-Icon.svg"
    alt="Search"
    class="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground"
  />
  <input
    [(ngModel)]="searchField"
    type="text"
    [placeholder]="placeholderText"
    class="pl-8 w-full py-1 border-2 rounded text-sm"
  />
  <button
    (click)="onSearch()"
    class="bg-primary absolute h-full z-10 right-0 px-2 rounded-r"
  >
    <img
      loading="lazy"
      src="assets/icons/Search-Icon.svg"
      alt="Search"
      class="h-4 w-4 icon-white"
    />
  </button> -->

  <!-- Name Input -->
  <input
    type="text"
    [(ngModel)]="searchField"
    [placeholder]="placeholderText"
    class="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
  />

  <!-- Search Button -->
  <button
    (click)="onSearch()"
    class="px-6 py-2 bg-teal-600 text-white rounded-md hover:bg-teal-700 flex items-center gap-2 text-sm font-medium whitespace-nowrap"
  >
    <img
      loading="lazy"
      src="assets/icons/Search-Icon.svg"
      alt="Search"
      class="h-4 w-4 icon-white"
    />
    Search
  </button>

  <!-- Reset Button -->
  <button
    (click)="onResetFilters()"
    class="px-6 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 flex items-center gap-2 text-sm font-medium whitespace-nowrap"
  >
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="{2}"
        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
      />
    </svg>
    Reset
  </button>
</div>
